import { useAuth } from "./useAuth";

/**
 * True when the logged-in user holds the platform SUPER_ADMIN role.
 *
 * Distinct from {@link useIsReadOnly}, which reflects the *session* role and is
 * therefore false for a super admin who is also a member of the current org.
 */
export const useIsSuperAdmin = () => {
  const { isSuperAdmin } = useAuth();
  return isSuperAdmin;
};
